export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/codebuild/output/src4183194827/src/greenet-portal/src/pages/index.vue'),
    /* no children */
    meta: {
      "layout": "admin"
    }
  },
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/codebuild/output/src4183194827/src/greenet-portal/src/pages/[...all].vue'),
    /* no children */
    meta: {
      "layout": "error"
    }
  },
  {
    path: '/brand-info',
    /* internal name: '/brand-info' */
    /* no component */
    children: [
      {
        path: '',
        name: '/brand-info/',
        component: () => import('/codebuild/output/src4183194827/src/greenet-portal/src/pages/brand-info/index.vue'),
        /* no children */
        meta: {
          "layout": "admin"
        }
      }
    ],
  },
  {
    path: '/company-profile',
    /* internal name: '/company-profile' */
    /* no component */
    children: [
      {
        path: '',
        name: '/company-profile/',
        component: () => import('/codebuild/output/src4183194827/src/greenet-portal/src/pages/company-profile/index.vue'),
        /* no children */
        meta: {
          "layout": "admin"
        }
      }
    ],
  },
  {
    path: '/dashboard',
    /* internal name: '/dashboard' */
    /* no component */
    children: [
      {
        path: '',
        name: '/dashboard/',
        component: () => import('/codebuild/output/src4183194827/src/greenet-portal/src/pages/dashboard/index.vue'),
        /* no children */
        meta: {
          "layout": "admin"
        }
      }
    ],
  },
  {
    path: '/draft-products',
    /* internal name: '/draft-products' */
    /* no component */
    children: [
      {
        path: '',
        name: '/draft-products/',
        component: () => import('/codebuild/output/src4183194827/src/greenet-portal/src/pages/draft-products/index.vue'),
        /* no children */
        meta: {
          "layout": "admin"
        }
      }
    ],
  },
  {
    path: '/login',
    /* internal name: '/login' */
    /* no component */
    children: [
      {
        path: '',
        name: 'login',
        component: () => import('/codebuild/output/src4183194827/src/greenet-portal/src/pages/login/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/published-products',
    /* internal name: '/published-products' */
    /* no component */
    children: [
      {
        path: '',
        name: '/published-products/',
        component: () => import('/codebuild/output/src4183194827/src/greenet-portal/src/pages/published-products/index.vue'),
        /* no children */
        meta: {
          "layout": "admin"
        }
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

